import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-room-bed-types',
  templateUrl: 'room-bed-types.component.html'
})
export class RoomBedTypesComponent {
  @Input() composition: any;
}
